import { attr } from '@ember-data/model';
import { readOnly } from '@ember/object/computed';
import ItemsV3Base from '@square/dashboard-items-data/models/items-v3-base';
export default ItemsV3Base.extend({
  enabledUnitsAll: attr('boolean', {
    defaultValue: false
  }),
  itemSubunit: readOnly('effectiveEnabledUnits.firstObject'),
  subunitToken: readOnly('itemSubunit.token'),
  name: attr('string'),
  description: attr('string'),
  subunitName: readOnly('itemSubunit.nickname')
}).reopenClass({
  _modelNameForMigration: 'resource',
  sortKey: 'name',
  catalogType() {
    return 'RESOURCE';
  }
});